// extracted by mini-css-extract-plugin
module.exports = {"root":"ProgramDetail_root__Ff58h","collapse":"ProgramDetail_collapse__P_I8B","angleLeft":"ProgramDetail_angleLeft__I9u7w","angleRight":"ProgramDetail_angleRight__WMPek"};